import { ComponentAPI } from '@philips-internal/oswald-ui-core';
import { HeadingProperties } from './heading-types.js';
class HeadingAPI extends ComponentAPI {
    /**
     * Gets the inline actions desktop limit.
     */
    getInlineActionsDesktopLimit() {
        return this.state.inlineActionsDesktopLimit ?? HeadingProperties.inlineActionsDesktopLimit.defaultValue;
    }
    /**
     * Sets the inline actions desktop limit.
     *
     * @param inlineActionsDesktopLimit - The inline actions desktop limit.
     */
    setInlineActionsDesktopLimit(inlineActionsDesktopLimit) {
        this.setState({ ...this.state, inlineActionsDesktopLimit });
    }
    /**
     * Gets the heading theme.
     */
    getTheme() {
        return this.state.theme ?? HeadingProperties.theme.defaultValue;
    }
    /**
     * Sets the heading theme.
     *
     * @param theme - The heading theme.
     */
    setTheme(theme) {
        this.setState({ ...this.state, theme });
    }
    /**
     * Gets the heading title.
     */
    getTitle() {
        return this.state.title;
    }
    /**
     * Sets the heading title.
     *
     * @param title - The heading title.
     */
    setTitle(title) {
        this.setState({ ...this.state, title });
    }
}
export { HeadingAPI, };
//# sourceMappingURL=heading-api.js.map